import { useState } from 'react'
import { useSelector } from 'react-redux'
import './NavHeader.css'
import IPAMenu from './IPAMenu/IPAMenu'
import DevicesMenu from './DevicesMenu/DevicesMenu'
import DataMenu from './DataMenu/DataMenu'
import ServerMenu from './ServerMenu/ServerMenu'
import UserMenu from './UserMenu/UserMenu'
import TimeZone from './TimeZone/TimeZone'
import ExtensionMenu from './ExtensionMenu/ExtensionMenu'
import Logo from '../../logo.png'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavbarText,
} from 'reactstrap'
import { DefaultState } from '../../types'

const NavHeader = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { user } = useSelector((state:DefaultState) => state.session.data)
  const toggle = () => setIsOpen(!isOpen)
  const navLabels = {
    dashText: 'Dashboard',
    archiveText: 'Data Archive',
    orgText: 'Organizations',
    ipaText: 'IPA',
    devicesText: 'Devices',
    serverText: 'Server',
    displayUser: true,
  }
  return (
    <Navbar className='color-nav' expand='md'>
      <a href='/ui/#!/' className='navbarBrand'>
        <img className='logo' src={Logo} />
      </a>
      <NavbarToggler onClick={toggle} />

      <Collapse isOpen={isOpen} navbar id='collapse'>
        <Nav id='nav_ul' className='mr-auto' navbar>
          <NavItem>
            <a className='glyphicons glyphicons-dashboard nav-link' href='/ui/#!/'>
              <p className='nav-link-p'>{navLabels.dashText}</p>
            </a>
          </NavItem>
          <DataMenu label={navLabels.archiveText}/>
          <IPAMenu label={navLabels.ipaText} />
          <DevicesMenu label={navLabels.devicesText}/>
          {user?.roles?.includes("admin") && <NavItem>
            <a
              className='glyphicons glyphicons-tree-structure nav-link'
              href='/ui/#!/organizations'
            >
               <p className='nav-link-p'>{navLabels.orgText}</p>
            </a>
          </NavItem>}
          {user?.roles?.includes("admin") && <ServerMenu label={navLabels.serverText} />}
          <UserMenu user={user} firstName={user?.profile?.first_name} lastName={user?.profile?.last_name}/>
          <ExtensionMenu />
        </Nav>
        <NavbarText>
          <TimeZone />
        </NavbarText>
      </Collapse>
    </Navbar>
  )
}

export default NavHeader